module.exports = __webpack_public_path__ + "static/20220930.3f75653a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/20220930.png
// module id = 998
// module chunks = 2